function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { Image, ScrollView, TouchableOpacity, View } from "react-native";
import { Kind } from "@oui/lib/src/types";
import { Text } from "./Text";
/**
 * @deprecated
 * @nosync
 */ export var ChatInputCarousel = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ChatInputCarousel, Component);
    function ChatInputCarousel() {
        _class_call_check(this, ChatInputCarousel);
        return _call_super(this, ChatInputCarousel, arguments);
    }
    _create_class(ChatInputCarousel, [
        {
            key: "onChooseItem",
            value: function onChooseItem(value) {
                var onInput = this.props.onInput;
                if (onInput) {
                    onInput({
                        kind: Kind.InputCarousel,
                        props: value
                    });
                }
            }
        },
        {
            key: "renderItem",
            value: function renderItem(item) {
                var _this = this;
                return /*#__PURE__*/ _jsxs(TouchableOpacity, {
                    style: {
                        width: 250,
                        height: 200,
                        backgroundColor: 'white',
                        borderRadius: 16,
                        borderTopStartRadius: 0,
                        padding: 16,
                        alignItems: 'center',
                        marginRight: 12
                    },
                    onPress: function() {
                        return _this.onChooseItem(item.ID);
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                flex: 1,
                                alignSelf: 'stretch',
                                marginBottom: 16
                            },
                            children: /*#__PURE__*/ _jsx(Image, {
                                style: {
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 16
                                },
                                source: {
                                    uri: item.thumbnail
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: item.label,
                            color: "#f46123",
                            weight: "bold",
                            size: 18
                        })
                    ]
                }, item.ID);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ _jsxs(View, {
                    style: {
                        alignItems: 'center',
                        padding: 12
                    },
                    children: [
                        /*#__PURE__*/ _jsx(ScrollView, {
                            horizontal: true,
                            style: {
                                marginVertical: 8,
                                minWidth: '100%'
                            },
                            children: this.props.items.map(function(i) {
                                return _this.renderItem(i);
                            })
                        }),
                        this.props.allowSkip ? /*#__PURE__*/ _jsx(TouchableOpacity, {
                            onPress: function() {
                                return _this.onChooseItem('');
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                text: "Skip",
                                color: "#f46123",
                                weight: "bold",
                                style: {
                                    marginVertical: 8
                                },
                                size: 18
                            })
                        }) : null
                    ]
                });
            }
        }
    ]);
    return ChatInputCarousel;
}(Component);
_define_property(ChatInputCarousel, "defaultProps", {
    items: [
        {
            ID: '1',
            label: 'Cat 1',
            thumbnail: 'https://placekitten.com/625/225'
        },
        {
            ID: '2',
            label: 'Cat 2',
            thumbnail: 'https://placekitten.com/425/225'
        },
        {
            ID: '3',
            label: 'Cat 3',
            thumbnail: 'https://placekitten.com/425/340'
        }
    ]
});
